/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Political_Science21Inputs */

const en__field_enum_study_political_science21 = /** @type {(inputs: _Field_Enum_Study_Political_Science21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Political Science`)
};

const de__field_enum_study_political_science21 = /** @type {(inputs: _Field_Enum_Study_Political_Science21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politikwissenschaft`)
};

/**
* | output |
* | --- |
* | "Political Science" |
*
* @param {_Field_Enum_Study_Political_Science21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_political_science21 = /** @type {((inputs?: _Field_Enum_Study_Political_Science21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Political_Science21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_political_science21(inputs)
	return de__field_enum_study_political_science21(inputs)
});
export { _field_enum_study_political_science21 as "_field_enum_STUDY_POLITICAL_SCIENCE" }